import { render, staticRenderFns } from "./ShowEventRequestDialog.vue?vue&type=template&id=e37f5d84&"
import script from "./ShowEventRequestDialog.vue?vue&type=script&lang=js&"
export * from "./ShowEventRequestDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports